import React, { useEffect, useState } from 'react';
import styles from './viewOfferReview.module.scss';
import { Container, Col, Row, Modal, Table, Button, Card, Alert } from 'react-bootstrap';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { getPresignedUrlToViewOfferLetter, getPresignedUrlToViewCandidateSignedOfferLetter } from '../../../../services/util/offerHandling';

const ViewScheduledInterview = (props) => {
    let [tableValueState, setTableValueState] = useState();
    let checkCandidateInterviewStateArray = [];

    let [isDownloadSentOfferLetterLoading, setIsDownloadSentOfferLetterLoading] = useState(false);
    let [isDownloadSignedOfferLetterLoading, setIsDownloadSignedOfferLetterLoading] = useState(false);

    const createTableData = () => {

        // //check interviewers response
        // (props.showRowValues.assigned_interviewers).forEach(element => {
        //     checkCandidateInterviewStateArray.push(element.interviwer_interview_state)
        // });

        //check all values inside array equal to 1 (is accepted)
        // const allAccepted = arr => arr.every(val => val === arr[0] && val === 1);
        // let accept = allAccepted(checkCandidateInterviewStateArray);


        let tableValues = [];

        //Interviwers values push to array
        (props.viewOfferValues.offerReviewers).forEach(element => {
            let values = {
                email: '',
                name: '',
                state: 1,
                stateMessage: '',
            }
            values.email = element.email;
            values.name = element.first_name + ' ' + element.last_name;
            values.state = element.review.state;
            values.stateMessage = element.review.comments;
            tableValues.push(values);
        });

        let tableBody = tableValues.map((value, index) => {
            return (
                <tbody key={index}>
                    <tr>
                        <td className={styles.nameData} >{value.email}&nbsp;&nbsp;{<span className={styles.candidateRoleTag}>({value.name})</span>}</td>
                        <td className={styles.interviewData} data-tooltip-id={value.email + 'state'}>{value.state === 0 ? <span><i className="fas fa-info-circle text-warning fa-md"></i>&nbsp;&nbsp;Pending</span> : value.state === -10 ? <span><i className="fas fa-times-circle text-danger fa-md"></i>&nbsp;&nbsp;Rejected</span> : value.state === 10 ? <span><i className="fas fa-check-circle text-success fa-md"></i>&nbsp;&nbsp;Approved</span> : null}</td>
                    </tr>
                    {value.stateMessage && <ReactTooltip id={value.email + 'state'} place="right" type="dark" effect="solid">{value.stateMessage}</ReactTooltip>}
                </tbody>
            )
        })

        setTableValueState(tableBody)
    }

    //get download link of Submitted offer letter 
    const getURLForSubmittedOfferLetter = async () => {
        setIsDownloadSentOfferLetterLoading (true);
        let response = await getPresignedUrlToViewOfferLetter(props.viewOfferValues.offerSessionId);
        if (response.success == true) {
            window.open(response.data.presigned_url);
            setIsDownloadSentOfferLetterLoading (false);
        }
        else{
            setIsDownloadSentOfferLetterLoading (false);
        }
    }

    //get downlad link of submitted candidate signed offer letter
    const getURLForSubmittedCandidateSignedOfferLetter = async () => {
        setIsDownloadSignedOfferLetterLoading(true);
        let response = await getPresignedUrlToViewCandidateSignedOfferLetter(props.viewOfferValues.offerSessionId);
        if (response.success == true) {
            window.open(response.data.presigned_url)
            setIsDownloadSignedOfferLetterLoading(false);
        }
        else{
            setIsDownloadSignedOfferLetterLoading (false);
        }
    }


    useEffect(() => {
        createTableData();
    }, [])

    return (
        <div>
            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="lg"
            >

                <Modal.Body>

                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <div className={styles.modalHeaderDiv}>
                        <span className={styles.modalHeader}>Offer Details</span>
                        {(props.viewOfferValues.state === 10 || props.viewOfferValues.state === 30 || props.viewOfferValues.state === 31) ? <span className={styles.badgeType}>{props.viewOfferValues.stateValue}</span> : (props.viewOfferValues.state === 0 || props.viewOfferValues.state === 20 || props.viewOfferValues.state === 21) ? <span className={styles.badgeTypeWarning}>{props.viewOfferValues.stateValue}</span> : (props.viewOfferValues.state === -10 || props.viewOfferValues.state === -20  || props.viewOfferValues.state == -21) ? <span className={styles.badgeTypeDanger}>{props.viewOfferValues.stateValue}</span> :''}


                    </div>

                    <Container>
                        <div className="mb-4">
                            <Card className={styles.modalCard}>
                                <Card.Header className={styles.modalCardHeader}>
                                    VACANCY DETAILS
                                </Card.Header>
                                <Card.Body className={styles.modalCardBody}>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Pipeline Name</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.pipelineName}</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>
                        <div className="mb-4">
                            <Card className={styles.modalCard}>
                                <Card.Header className={styles.modalCardHeader}>
                                    CANDIDATE DETAILS
                                </Card.Header>
                                <Card.Body className={styles.modalCardBody}>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Name</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.candidateName}</p>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Email</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.candidateEmail}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Phone</p>
                                        </Col>
                                        <Col>
                                            {(props.viewOfferValues.candidatePhoneCode && props.viewOfferValues.candidatePhoneNumber) ?
                                                <p className={styles.cardValues}>({props.viewOfferValues.candidatePhoneCode})&nbsp;{props.viewOfferValues.candidatePhoneNumber}</p>
                                                :
                                                <p className={styles.cardValues}>Not available</p>
                                            }
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>

                        <div className="mt-4">
                            <Card className={styles.modalCard}>
                                <Card.Header className={styles.modalCardHeader}>
                                    OFFER DETAILS
                                </Card.Header>
                                <Card.Body className={styles.modalCardBody}>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Job Title</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.jobTitle}</p>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Allocation</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.allocation ? props.viewOfferValues.allocation : 'Not available'}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Description</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}> {props.viewOfferValues.offerDescription ? props.viewOfferValues.offerDescription : 'Not available'}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Package Reference</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.packageReference ? props.viewOfferValues.packageReference : 'Not available'}</p>
                                        </Col>
                                    </Row>
                                    {/* {props.viewOfferValues.candidateRejectReason &&
                                        <Row>
                                            <Col md={4}>
                                                <p className={styles.cardTopics}>Rejected Reason</p>
                                            </Col>
                                            <Col>
                                                <p className={styles.cardValues}>{props.viewOfferValues.candidateRejectReason ? props.viewOfferValues.candidateRejectReason : 'Not available'}</p>
                                            </Col>
                                        </Row>} */}

                                </Card.Body>
                            </Card>
                        </div>
                    </Container>


                    <Container>

                        <div>
                            <p className={styles.stepSubtopicName}>
                                Reviewer's Status Details
                            </p>
                        </div>

                        <Table bordered hover size="md" responsive className={styles.detailsTable}>
                            <thead>
                                <tr>
                                    <th className={styles.nameColumn}>Reviewer</th>
                                    <th className={styles.statusColumn}> STATUS</th>
                                </tr>
                            </thead>
                            {tableValueState ? tableValueState : null}
                        </Table>
                    </Container>

                    {/* if offer sent and above stages available */}
                    {(props.viewOfferValues.state == 20 || props.viewOfferValues.state == 30 || props.viewOfferValues.state == -20 ) &&
                        <Container>
                            <div className={styles.candidateResponseSection}>
                                <Card className={styles.modalCard}>
                                    <Card.Header className={styles.modalCardHeader}>
                                        CANDIDATE RESPONSE
                                    </Card.Header>
                                    <Card.Body className={styles.modalCardBody}>
                                        <Row>
                                            <Col md={4}>
                                                <p className={styles.cardTopics}>Offer Sent Mode</p>
                                            </Col>
                                            <Col>
                                                <p className={styles.cardValues}>{(props.viewOfferValues.offer_sent_mode === 10) ? 'Externally' : 'Via HireTrace'}</p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={4}>
                                                <p className={styles.cardTopics}>Offer Sent Date</p>
                                            </Col>
                                            <Col>
                                                <p className={styles.cardValues}>{props.viewOfferValues.offer_sent_date}</p>
                                            </Col>
                                        </Row>

                                        {(props.viewOfferValues.offer_sent_mode === 20) &&
                                            <Row>
                                                <Col md={4}>
                                                    <p className={styles.cardTopics}>Sent Offer Letter</p>
                                                </Col>
                                                <Col>

                                                    <Row>
                                                        <Col lg={1}>
                                                            { !isDownloadSentOfferLetterLoading ?<svg id={styles.downloadIcon}
                                                                onClick={() => getURLForSubmittedOfferLetter()}
                                                                //  onClick={() => window.open(props.data.candidate_signed_offer_letter_url)} 
                                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                                                                :<i className={`${"fas fa-spinner fa-spin"} ${styles.loadingIcon}`}></i>
                                                            } 
                                                        </Col>
                                                        <Col >
                                                            <p className={styles.cardValues}>Submitted File </p>
                                                        </Col>

                                                    </Row>

                                                    {/* <Row>
                                                    <Col >
                                                        <p className={styles.cardValues}>Not Available </p>
                                                    </Col>

                                                </Row> */}


                                                </Col>
                                            </Row>}

                                        <Row>
                                            <Col md={4}>
                                                <p className={styles.cardTopics}>Candidate Response</p>
                                            </Col>
                                            <Col>
                                                <p className={styles.cardValues}>{(props.viewOfferValues.state === 30) ? 'Accepted' : (props.viewOfferValues.state === -20) ? 'Declined' : (props.viewOfferValues.state === 20) ? 'Pending' : 'Not Available '}</p>
                                            </Col>
                                        </Row>
                                        {props.viewOfferValues.candidateRejectReason &&
                                            <Row>
                                                <Col md={4}>
                                                    <p className={styles.cardTopics}>Rejected Reason</p>
                                                </Col>
                                                <Col>
                                                    <p className={styles.cardValues}> {(props.viewOfferValues.candidateRejectReason && props.viewOfferValues.state === -20)  ? props.viewOfferValues.candidateRejectReason : 'Not available'}</p>
                                                </Col>
                                            </Row>}
                                        {props.viewOfferValues.candidate_respose_date &&
                                            <Row>
                                                <Col md={4}>
                                                    <p className={styles.cardTopics}>Responded Date</p>
                                                </Col>
                                                <Col>
                                                    <p className={styles.cardValues}>{props.viewOfferValues.candidate_respose_date ? props.viewOfferValues.candidate_respose_date : 'Not available'}</p>
                                                </Col>
                                            </Row>}
                                        {(props.viewOfferValues.offer_sent_mode === 20 && props.viewOfferValues.state == 30) &&
                                            <Row>
                                                <Col md={4}>
                                                    <p className={styles.cardTopics}>Signed Offer Letter</p>
                                                </Col>
                                                <Col>

                                                    {props.viewOfferValues.candidate_respose_received_mode ==20 ?<Row>
                                                        <Col lg={1}>
                                                            { !isDownloadSignedOfferLetterLoading ?<svg id={styles.downloadIcon}
                                                                onClick={() => getURLForSubmittedCandidateSignedOfferLetter()}
                                                                //  onClick={() => window.open(props.data.candidate_signed_offer_letter_url)} 
                                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                                                                :<i className={`${"fas fa-spinner fa-spin"} ${styles.loadingIcon}`}></i>
                                                            } 
                                                        </Col>
                                                        <Col >
                                                            <p className={styles.cardValues}>Submitted File </p>
                                                        </Col>

                                                    </Row>
                                                    :
                                                    <Row>
                                                        <Col >
                                                            <p className={styles.cardValues}>Not Available (response received externally)  </p>
                                                        </Col>
                                                    </Row>
                                                    
                                                    }


                                                </Col>
                                            </Row>}
                                    </Card.Body>
                                </Card>
                            </div>
                        </Container>}
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ViewScheduledInterview;
